import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "../theme";
/**
 * A flexible box component.
 */
export const Box = ({ className, children, ...styleProps }) => (_jsx("div", { className: className, style: {
        ...styleProps,
        display: "flex",
    }, children: children }));
Box.defaultProps = {
    alignContent: "stretch",
    alignItems: "stretch",
    alignSelf: "stretch",
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
};
/**
 * A flexible column component.
 */
export const FlexColumn = styled.div `
  display: flex;
  flex-direction: column;
`;
/**
 * A flexible row component with space-between justification.
 */
export const FlexRow = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
/**
 * A flexible row component with centered alignment.
 */
export const FlexRowCenter = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
